<script setup>
import { ref, nextTick, onMounted, onBeforeUnmount  } from 'vue'
import * as signalR from "@microsoft/signalr";

const input = ref('')
const messages = ref([
  {id : 0, role: 'assistant', content: 'Cześć! Zadaj mi pytanie 🙂' },
])
const messagesRef = ref(null)
const isGenerating = ref(false)

const messageRequest = ref({
  url: window.location.href,
  chatId: crypto.randomUUID(),
  model:"gemma3",
  message: { id: "", role: 'user', content: "" },
})

const modelsList = ref([
  { id: 1, text: 'gemma3', value: 'gemma3' },
  { id: 2, text: 'llama3.2', value: 'llama3.2' },
  { id: 3, text: 'smollm2', value: 'smollm2:135m' },
  { id: 4, text: 'bielik', value: 'mwiewior/bielik:latest' },
]);

async function sendMessage() {
  if (!input.value.trim()) 
    return
  var message_content = { id:  crypto.randomUUID(), role: 'user', content: input.value }
  messageRequest.value.message = message_content;
  input.value = ''
  messages.value.push(message_content)

  try {
      if (connection.state === signalR.HubConnectionState.Connected) {
        console.log("Połączony");
      }else{
        console.log("Nie jest połączony");
        await connection.start();
      }
    isGenerating.value=true;
    await connection.invoke("SendMessage", messageRequest.value);
  } catch (err) {
    isGenerating.value=false;
    if (err.toString().includes("Invocation canceled")) {
      console.log("Generowanie anulowane przez użytkownika");
    } else {
      console.error(err);
    }
  }

  // Symulowana odpowiedź bota
  // setTimeout(() => {
  //   messages.value.push({ role: 'assistant', content: 'To jest przykładowa odpowiedź AI.' })
  //   scrollToBottom()
  // }, 500)

  scrollToBottom()
}

function upsertMessage(id, role, text) {
  let msg = messages.value.find(m => m.id === id && m.role==='assistant');

  if (!msg) {
    msg = { id: id, role: role, content: text };
    messages.value.push(msg);
  } else {
    msg.content += text;
  }
}

function scrollToBottom() {
  nextTick(() => {
    messagesRef.value.scrollTop = messagesRef.value.scrollHeight
  })
}


//---------------------SIGNALR
const API_URL = process.env.VUE_APP_AI_URL;
const connection = new signalR.HubConnectionBuilder()
  .withUrl(API_URL+"aiChatSignalHub",
    {
      //skipNegotiation: true,
      //transport: signalR.HttpTransportType.WebSockets,
      ////Adding this line
      accessTokenFactory: () => localStorage.getItem("authToken")
  })
  .withAutomaticReconnect()
  .build();

connection.on("ReceiveMessage", (data)  => {
  console.log("<<ReceiveMessage",data);
   upsertMessage(data.id, data.role, data.content);
   scrollToBottom();
});

connection.on("EndMessage", (id) => {
  console.log("<<EndMessage",id);
  isGenerating.value=false;
  //upsertMessage(message, 'assistant', "[.]");
});

connection.on("AIController", (data) => {
   console.log("<<AIController",data);
});

onBeforeUnmount(() => {
  try{
    connection.stop(); // automatycznie anuluje ct w Hubie
  } catch (err) {
      console.error(err);
    }
});

onMounted(async () => {
  try{
    await connection.start();
   } catch (err) {
    if (err.toString().includes("Invocation canceled")) {
      console.log("Generowanie anulowane przez użytkownika");
    } else {
      console.error(err);
    }
  }
});
function cancelGeneration() {
  connection.stop(); // anuluje CancellationToken po stronie .NET
}
//---------------------SIGNALR
</script>

<style scoped>
.app {
display: flex;
flex-direction: column;
height: 90vh;
background: #0f172a;
color: #e5e7eb;
font-family: system-ui, sans-serif;
}


.header {
padding: 12px;
background: #020617;
text-align: center;
font-weight: bold;
}


.messages {
flex: 1;
overflow-y: auto;
padding: 16px;
}


.message {
margin-bottom: 12px;
display: flex;
}


.message.user {
justify-content: flex-end;
}


.message.assistant {
justify-content: flex-start;
}


.bubble {
max-width: 70%;
padding: 10px 14px;
border-radius: 12px;
line-height: 1.4;
}


.message.user .bubble {
background: #2563eb;
}


.message.assistant .bubble {
background: #1e293b;
}


.input-bar {
display: flex;
padding: 10px;
background: #020617;
}


textarea {
flex: 1;
resize: none;
padding: 10px;
border-radius: 8px;
border: none;
outline: none;
}


button {
margin-left: 8px;
padding: 0 16px;
border-radius: 8px;
border: none;
background: #22c55e;
cursor: pointer;
}
</style>

<template>
  <div class="app">
    <header class="header">AI Chat UI
      <div class="col-md-12">
        <select v-model="messageRequest.model">
          <option disabled value="">Please select one</option>
          <option v-for="item in modelsList" :key="item.id" :value="item.value">
            {{ item.text }}
          </option>
        </select>
      </div>
    </header>
    <main class="messages" ref="messagesRef">
      <div
        v-for="(msg, index) in messages"
        :key="index"
        :class="['message', msg.role]"
      >
        <div class="bubble" style="white-space: pre-line;">{{ msg.content }}</div>
      </div>
    </main>

    <footer class="input-bar">
      <textarea
        v-model="input"
        placeholder="Zadaj pytanie..."
        @keydown.enter.prevent="sendMessage"
      ></textarea>
      <button v-if="!isGenerating" @click="sendMessage">Wyślij</button>
      <button v-if="isGenerating" @click="cancelGeneration" style="background-color: gray;">Anuluj</button>
    </footer>
  </div>
</template>


